<template>
  <div class="container">
    <div class="topTab">
      <div
        class="topTab_item"
        :class="{'topTab_item_active':index==activeIndex}"
        v-for="(item,index) in tab"
        @click="changeTab(index)"
        :key="index"
      >
        <p>{{item}}</p>
        <span class="line"></span>
      </div>
    </div>
    <div class="bottomTab_t">2222</div>
    <div class="dataList">
      <Scroll
        :data="visitorList"
        :allLoaded="allLoaded"
        @pulldown="loadData"
        @loadUp="loadup"
        v-if="visitorList.length"
      >
        <div
          class="dataItem"
          v-for="(item,index) in visitorList"
          :key="index"
          @click="details(item.id)"
        >
          <div class="dataItem_line">
            <span class="line_title">来访日期</span>
            <span class="line_text">{{item.visitorDate}}</span>
          </div>
          <div class="dataItem_line">
            <span class="line_title">访客姓名</span>
            <span class="line_text">{{item.visitorUserName}}</span>
          </div>
          <div class="dataItem_line">
            <span class="line_title">访客电话</span>
            <span class="line_text">{{item.visitorMobile}}</span>
          </div>
          <div class="dataItem_line" v-if="item.visitorFloor">
            <span class="line_title">来访地址</span>
            <span class="line_text">{{item.visitorFloor}}</span>
          </div>
          <div
            class="dataItem_status"
            :class="{'status_active2':item.status==2,'status_active1':item.status==1,'status_active6':item.status==6||item.status==3}"
          >{{item.status|statusFilters}}</div>
        </div>
      </Scroll>
      <nomessage v-if="!visitorList.length"></nomessage>
    </div>
    <div class="bottomTab_h">2222</div>
  </div>
</template>

<script>
import nomessage from "../../../components/nomessage";
import { getVisitorListByMarketId } from "../../../utils/api";
import Scroll from "../../../components/scroll";
import util from "../../../utils/util";
import { mapState } from "vuex";
export default {
  name: "yaoQing",
  data() {
    return {
      activeIndex: 0,
      tab: ["全部", "预约成功", "来访结束"],
      pageNo: 1,
      pageSize: 10,
      allLoaded: false, // 可以进行上拉
      loaded: false,
      mode: "1", //0拜访 1邀请
      visitorList: []
    };
  },
  watch: {
    $route(to, from) {
      console.log("from.name");
      console.log(from.name);
      if (from.name === "visitDetails") {
        this.pageNo = 1;
        this.fetchData();
      }
    }
  },
  components: {
    Scroll,
    nomessage
  },
  computed: {
    ...mapState({
      // openId: state => state.common.openId,
      userId: state => state.common.userId,
      marketInfo: state => state.common.marketInfo
    })
  },
  filters: {
    statusFilters(status) {
      switch (status) {
        case 1:
          return "已发预约";
        case 2:
          return "预约成功";
        case 3:
        case 6:
          return "审批未通过";
        case 4:
          return "已取消";
        case 5:
          return "来访结束";
      }
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    // 上拉加载
    loadup() {
      if (this.allLoaded) {
        return;
      }
      this.pageNo++;
      this.fetchData();
    },
    // 下拉刷新
    loadData() {
      this.pageNo = 1;
      util.showLoading();
      this.fetchData();
    },
    fetchData() {
      getVisitorListByMarketId({
        userId: this.userId,
        marketId: this.marketInfo.id,
        type:
          this.activeIndex == 0
            ? (0).toString()
            : (this.activeIndex + 1).toString(),
        pageNo: this.pageNo,
        mode: this.mode,
        pageSize: 10
      }).then(res => {
        console.log("res");
        console.log(res);
        util.hideLoading();
        if (res.body) {
          let data = res.body.visitorList;
          if (data.length !== 10) {
            this.allLoaded = true; // 若数据已全部获取完毕
          }
          if (this.pageNo === 1) {
            this.visitorList = data;
          } else {
            this.visitorList = [...this.visitorList, ...data];
          }
        } else {
          this.visitorList = [];
        }
      });
    },
    details(id) {
      let mode = this.mode;
      this.$router.push(`/visitDetails?id=${id}&mode=${mode}`);
    },
    changeTab(index) {
      this.activeIndex = index;
      this.pageNo = 1;
      this.fetchData();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
@import "common.less";
</style>
